export class SourceCreationError extends Error
{
}

export class MethodNotImplemented extends Error
{
}
